import styled from "styled-components"

export const Link = styled.a`
  text-decoration: underline;
  :hover {
    text-decoration: none;
  }
`
